import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import { theme, Theme } from '../store/theme';
import styles from './FollowBlock.module.scss';
import Img from './Img';
import ConsultationForm, { SubmitButtonView, SubmitType } from '../page-components/Home/Consultation/ConsultationForm';

const formId = 'follow-block-form';

const FollowBlock = ({ className, imageClassName }: { className?: string, imageClassName?: string }) => {
  const appTheme = useAtomValue<Theme>(theme);

  return (
    <section className={classnames(styles.follow, className)}>
      <div className={classnames(styles.image, imageClassName)}>
        <Img
          src={`/media/follow_us_${appTheme}.svg`}
          alt='follow us image'
        />
      </div>
      <h4 className={classnames(styles.title, 'header4')}>Follow us</h4>
      <p className={classnames(styles.text, 'bodyLarge')}>Be the first to explore fresh ideas, tips, and tools</p>
      <ConsultationForm
        type={SubmitType.NEWSLETTER}
        className={styles.newsLetterForm}
        formId={formId}
        submitButtonView={SubmitButtonView.full}
        submitButtonText='Subscribe'
        formClassNames={{
          input: styles.followInput,
          status: styles.followStatus,
          button: styles.followButton,
        }}
      />
    </section>
  );
};

export default FollowBlock;
